import React from "react";
import { connect } from "react-redux";
import { startLoginAsGuest } from "../actions/auth";
import { Link } from "react-router-dom";
import Logo from "../assets/images/up-logo.svg";
import "../styles/components/login.scss";
import "../styles/components/button.scss";

class SignupPage extends React.Component {
  componentDidMount() {
    if (this.props.asGuest) {
      this.props.startLoginAsGuest();
    }
  }

  render() {
    return (
      <div className="box-layout__box">
        <div className="box-left">
          <h4>Try it!</h4>
          <p>Get a free tour in updamus then decide.</p>
          <button
            className="button-guest"
            onClick={this.props.startLoginAsGuest}
          >
            Login as Guest
          </button>
        </div>
        <a href="https://updamus.com">
          <img src={Logo} alt="logo" />
        </a>
        <div className="box-layout__box__container">
          <div className="box-layout__box__header">
            <h2>Sign up is currently disabled</h2>
            <p>New registrations are not available at this time.</p>
          </div>
          <div className="signup-disabled-banner">
            <p className="signup-disabled-banner__text" dir="rtl" lang="fa">
              {"امکان ایجاد حساب کاربری جدید وجود ندارد."}
            </p>
          </div>
          <p className="signup-disabled-hint">
            You can still <strong>Login as Guest</strong> on the left or use an
            existing account below.
          </p>
        </div>
        <div className="fancy-detour">
          <p>Already have an account?</p>
          <Link to="/login" className="button-guest">
            Login
          </Link>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  fetchInProgress: state.fetchInProgress
});

const mapDispatchToProps = dispatch => ({
  startLoginAsGuest: () => dispatch(startLoginAsGuest())
});

export default connect(mapStateToProps, mapDispatchToProps)(SignupPage);
